import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { DataCardTeamRankingQuery } from '../types';

/**
 * typeguard for DataCardTeamRankingQuery
 * @param DataCardTeamRankingQuery object passed to transformer
 */
export const isValidDataCardTeamRanking = (obj: DataCardTeamRankingQuery): boolean => Boolean(obj?.data?.getCardTeamRankingWidget && !isEmptyObject(obj.data.getCardTeamRankingWidget));
